import "./OneProjectPage.scss"
import "swiper/css"
import 'swiper/css/autoplay';
import Spinner from "../../components/Spinner/Spinner";
import { data, useParams } from "react-router-dom"
import { useState, useEffect } from "react"
import { Link } from "react-router-dom";
import FadeIn from "../../components/FadeIn/FadeIn";
import { getDataByLink } from "../../service/service";
import { _baseImageUrl } from "../../service/constants";

import {A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from 'swiper/react';

const Section = ({ children }) => {
  const [ref, isVisible] = FadeIn(0.2);
  return (
    <section ref={ref} className={`fade-in-section ${isVisible ? "visible" : ""}`}>
      {children}
    </section>
  )
}
const OneProjectPage = () => {
      const { link } = useParams()

      const [currProject, setCurrProject] = useState(null)

      useEffect(() => {
        getDataByLink("portfolio", link).then((data) => {
          const findPortData = data.find(el => el.link === link)
          if(findPortData){
            setCurrProject(findPortData)
          }else{
            setCurrProject(false)
          }
        }).catch(() => setCurrProject(false))
      }, [link])

      if (currProject === null) return <Spinner />
      if (!currProject) return <h2 style={{ margin: "150px auto", display: "block", width: "200px", color: "rgb(23, 39, 116)", fontWeight: "400" }}>❌ Project node found...</h2>

       return (

        <Section>
            <section className="one-proj">
            <div className="container">
                <Link to={"/portfolio/"}>&#8617; Back</Link>

                <div className="row">
                    <div className="one-proj__img">
                    <Swiper
                               modules={[ A11y, Autoplay]}
                               spaceBetween={50}
                               slidesPerView={1}
                               loop={true}
                               autoplay={{
                                 delay: 3500,
                                 disableOnInteraction: false, 
                               }}
                               onSwiper={(swiper) => console.log(swiper)}
                               onSlideChange={() => console.log('slide change')}
                             >
                               <SwiperSlide style={{ zIndex: 1 }}>   
                                     <img src={_baseImageUrl + currProject.image.path} alt="Project image" />
                                </SwiperSlide>

                               <SwiperSlide style={{ zIndex: 1 }}> 
                               <img src={_baseImageUrl + currProject.image2.path} alt="Project image" />
                                 </SwiperSlide>

                               <SwiperSlide style={{ zIndex: 1 }}>
                               <img src={_baseImageUrl + currProject.image3.path} alt="Project image" />
                               </SwiperSlide>
                             </Swiper>
                    </div>
                    <div className="one-proj__links">
                        <div className="one-proj__links-header">
                        <h3>{currProject.title}</h3>
                        <p>{currProject.headDescr}</p>
                        </div>
                        <div className="one-proj__links-btn">
                            <a target="_blank" href={currProject.link1}>View site</a>
                            <a target="_blank" href={currProject.link2}>View code</a>
                        </div>
                    </div>
                </div>
                <div className="one-proj__descr">
                    <p>What technologies were used:</p>
                      <p>{currProject.frontend}</p>
                      <p>{currProject.backend}</p>
                      <p>{currProject.description}</p>
                </div>
            </div>
        </section>
        </Section>
       )
}

export default OneProjectPage